import React from 'react';
import {
    useSsSelector as useSelector,
} from '~SpectateStore';

import {
    selectShowBetReceipt,
} from '~Betslip/selectors/betReceiptSelectors';
import {
    useIsUserLoggedIn,
    useShouldHideLogin,
} from '~SpectateStore/hooks/userHooks';

import BetslipCTAs from './BetslipCTAs';
import ReceiptCTAs from './ReceiptCTAs';

const CallToActions = () => {
    const showBetReceipt = useSelector(selectShowBetReceipt);
    const isLoggedIn = useIsUserLoggedIn();
    const shouldHideLogin = useShouldHideLogin();

    if (shouldHideLogin) {
        return null;
    }

    if (showBetReceipt && isLoggedIn) {
        return <ReceiptCTAs />;
    }

    return (
        <BetslipCTAs />
    );
};

export default CallToActions;
